import store from "@/store";


// 检查环境是否为微信或企微
export default function checkEnvironment() {
    console.log("checkEnvironment");
    
    const ua = navigator.userAgent.toLowerCase();

    // 1. 判断是否是微信内置浏览器 (MicroMessenger)
    const isWechat = ua.indexOf("micromessenger") !== -1;

    // 2. 判断是否是企业微信内置浏览器 (wxwork)
    const isComWechat = ua.indexOf("wxwork") !== -1;

    // 3. 如果在微信或企微中打开，立刻激活遮罩层
    if (isWechat || isComWechat) {
        store.commit("setShowWechatGuide", true);
        // 可选扩展：为了防止用户无法操作，强行锁死下方页面的滚动（低版本混淆优化）
        document.body.style.overflow = "hidden";
        return;
    }
}